import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { AuthService } from '@klickdata/core/auth';
import { Customer } from '@klickdata/core/customer';
import { Resource, ResourceService } from '@klickdata/core/resource';
import { Filter } from '@klickdata/core/table/src/table-filter/filter';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'app-resource-public-customers-sheet',
    templateUrl: './resource-public-customers-sheet.component.html',
    styleUrls: ['./resource-public-customers-sheet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourcePublicCustomersSheetComponent implements OnInit, OnDestroy {
    public assignForm: FormGroup;
    public destroy: Subject<boolean> = new Subject<boolean>();
    public saving: boolean;
    public selectionFilters: Filter<any>[];
    public customer$: Observable<Customer>;

    constructor(
        public bottomSheetRef: MatBottomSheetRef<ResourcePublicCustomersSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        protected fb: FormBuilder,
        protected resourceService: ResourceService,
        protected auth: AuthService
    ) {
        this.assignForm = this.fb.group({
            id: [],
            sync_all_customers: [],
            customers_attach: [[]],
            customers_detach: [[]],
        });
    }

    ngOnInit() {
        this.customer$ = this.auth
            .getCustomer()
            .pipe(
                tap(
                    (customer) =>
                        (this.selectionFilters = [
                            new Filter('cluster', [customer.id]),
                            new Filter('referenceResource', [this.data.id]),
                        ])
                )
            );

        this.assignForm.patchValue({ id: this.data.id });
    }

    public submit() {
        if (
            this.assignForm.value.sync_all_customers !== null ||
            this.assignForm.value.customers_attach?.length ||
            this.assignForm.value.customers_detach?.length
        ) {
            const data = new Resource(this.assignForm.value).getData();
            this.saving = true;
            this.resourceService
                .update(data)
                .pipe(
                    map((res) => {
                        this.assignForm.patchValue({ id: data.id });
                        return res;
                    }),
                    takeUntil(this.destroy)
                )
                .subscribe((res) => {
                    this.saving = false;
                    this.bottomSheetRef.dismiss(res);
                });
        } else {
            this.bottomSheetRef.dismiss();
        }
    }

    public ngOnDestroy() {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }
}
